import MarkdownIt from 'markdown-it';

export function textToMarkdown(
  text?: string,
  options = {}
): string | undefined {
  if (!text) {
    return;
  }

  const md = new MarkdownIt({ html: true, ...options });

  return md.render(text);
}

export function textReplace(
  text?: string,
  dictionary?: Record<string, string>
): string | undefined {
  if (!text || !dictionary) {
    return;
  }

  text = String(text);

  let counter = 3;

  while (counter--) {
    for (let key in dictionary) {
      text = text.replace(new RegExp(key, 'g'), dictionary[key]);
    }
  }

  return text;
}

export function abbreviateText(string: string, maxLength?: number): string {
  const parts = string.split(' ');
  const abbreviatedParts = parts.map((part) => part[0]);

  return abbreviatedParts.slice(0, maxLength || undefined).join('');
}
